import React from "react";

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const LastpaymentHover = ({ logs }) => {
  const paymentData = logs?.length > 0 ? logs : [];

  return (
    <div className="w-72 p-4 bg-white shadow-lg border border-gray-300 rounded-md">
      <h3 className="text-lg font-semibold text-[#213650] mb-2">Payments Logs</h3>
      {paymentData.length > 0 ? (
        <div className="grid grid-cols-2 gap-3">
          {paymentData.map((payment, index) => (
            <React.Fragment key={index}>
              {/* Left Column - Date & Amount */}
              <div className="flex flex-col space-y-1">
                <p className="text-sm font-semibold">{formatDate(payment.created_at)}</p>
                <p className="text-sm text-gray-600"> Received ₹{payment.paid_amount?.toLocaleString() || 0}</p>
              </div>

              {/* Right Column - Status */}
              <div className="flex justify-end items-center">
              <span
  className={`px-3 py-1 text-xs font-medium rounded-md ${
    payment.invoice_payment_status === "Complete"
      ? "bg-green-100 text-green-600"
      : payment.invoice_payment_status === "Partial"
      ? "bg-orange-100 text-orange-600"
      : "bg-yellow-100 text-yellow-600"
  }`}
>
  {payment.invoice_payment_status || "N/A"}
</span>

              </div>
            </React.Fragment>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500 text-center">No payment logs available</p>
      )}
    </div>
  );
};

export default LastpaymentHover;
